import type { SVGProps } from 'react';

/** Figma `metric-range.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricRangeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M5.72798 2.45312V15.544M8.18253 4.90767L5.72798 2.45312L3.27344 4.90767M12.2734 15.544V2.45312M14.728 13.0895L12.2734 15.544L9.81889 13.0895"
        stroke="#FB2337"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
